import { TextareaHTMLAttributes } from "react";

import * as S from './styles';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  containerStyles?: string;
  error?: string;
}


export function TextArea({ label, containerStyles, error, ...props }: Props) {
  return (
    <S.Container className={containerStyles}>
      {label && (
        <label htmlFor={props.id}>
          {label}
          {props.required && <S.RequiredHint> *</S.RequiredHint>}
        </label>
      )}

      <S.StyledTextArea error={error !== undefined} {...props} />

      {error && <small>{error}</small>}
    </S.Container>
  )
}